import {NgModule} from '@angular/core';
import {DrawingService} from 'app/drawing/service/drawing/drawing.service';
import {DrawingToScreenCommunicatorService} from 'app/drawing/service/screen-communicator/screen-communicator.service';

@NgModule({
    providers: [DrawingService, DrawingToScreenCommunicatorService],
})
export class DrawingServiceModule {}
